import clsx from 'clsx';
import { AmountUtils, PaletteUtils } from '@shared/utils';
import { ColorsEnum, Text } from '@shared/widgets';
import styles from './accountInfo.module.css';

interface IAccountInfoProps {
  className?: string;
  title?: string;
  type1?: string;
  user?: string;
  amount?: string | number;
  type2?: string;
  icon?: string;
  status?: string;
  children?: React.ReactNode;
}

export const AccountInfo = (props: IAccountInfoProps) => {
  return (
    <div className={clsx('rounded-sm bg-white dark:bg-soft-black', props.className)}>
      <div className='pb-4 flex justify-between'>
        <div className='min-w-0 pt-8 pr-4 pl-8 flex-none flex-grow relative z-10'>
          <Text className='mb-2 break-words' weight='medium' size='2xl'>
            {props.title}
          </Text>
          <Text weight='medium' size='xs' color={ColorsEnum.Gray} isUppercase>
            {props.type1}
          </Text>
          <div className='font-medium'>{props.user}</div>
          {props.amount != null && (
            <Text className='mt-2 font-[Prata]' size='4xl'>
              {props.icon}
              {AmountUtils.transformToAmountWithCurrency(props.amount as number)}
            </Text>
          )}
          {props.type2 && (
            <Text weight='medium' size='xs' color={ColorsEnum.Gray} isUppercase>
              {props.type2}
            </Text>
          )}
        </div>
        <div
          className={clsx(
            'w-48 h-40 pt-7 pr-1 pb-4 pl-14 rounded-tr-sm flex-none flex flex-col items-center justify-end text-center overflow-hidden relative',
            PaletteUtils.isInsigniaPalette && 'bg-soft-black dark:bg-slate before:border-r-primary',
            PaletteUtils.isVcfcPalette && 'bg-primary dark:before:border-r-ice',
            styles['account-info__top-right'],
          )}
        >
          <div
            className={clsx(
              'mb-3 before:content-[attr(data-icon)] after:content-[attr(data-icon)] ',
              PaletteUtils.isInsigniaPalette && 'before:text-primary after:text-primary',
              PaletteUtils.isVcfcPalette && 'before:text-white after:text-white',
              styles['account-info__icon'],
            )}
            data-icon={props.icon}
          />
          <Text weight='semibold' color={ColorsEnum.White}>
            {props.status}
          </Text>
        </div>
      </div>
      <div className='pt-3 px-9 pb-6'>{props.children}</div>
    </div>
  );
};
